import CheckOutPrompt from './CheckOutPrompt'

export default CheckOutPrompt
